import { useServicesContext, VehicleBasic } from '@oneaudi/vtp-shared';
import React, { useContext } from 'react';

import { ContentFields } from '../../../../types/editor';
import { ContentService } from '@oneaudi/content-service';
import { StageContext } from '../../hooks/StageContext';
import { IconButton } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';

interface AvpWebstreamButtonProps {
  vehicle?: VehicleBasic;
}

const createAndLoadWebstreamScript = (avpRessourceUrl: string) => {
  if (document?.querySelector('#js-avp-script') === null) {
    const script = document.createElement('script');
    script.setAttribute('id', 'js-avp-script');
    script.src = avpRessourceUrl;
    script.type = 'module';
    document?.head.appendChild(script);
  }
};

export const AvpWebstreamButton: React.FC<AvpWebstreamButtonProps> = ({ vehicle }) => {
  if (!vehicle) return null;

  const audiContentService = useServicesContext().getAdditionalService(
    'audi-content-service'
  ) as ContentService;
  const contentFields: ContentFields = audiContentService.getContent().fields;

  const ariaLabel3DButton = useI18n({
    defaultMessage: 'Open 3d view',
    id: 'stockcars.stage.button.3d.arialabel',
  });
  const isNewCar = vehicle?.type?.toLowerCase() === 'n';

  const showWebstreamButton =
    isNewCar &&
    contentFields?.use3dWebstreaming &&
    contentFields?.avpRessourceUrl &&
    contentFields?.configId;

  if (!showWebstreamButton) return null;

  const { setWebstreamLayerOpen, setWebstreamScriptLoading } = useContext(StageContext);

  const handleWebstreamOpen = () => {
    setWebstreamLayerOpen(true);
    setWebstreamScriptLoading(true);
    createAndLoadWebstreamScript(contentFields?.avpRessourceUrl);
  };

  return (
    <>
      <IconButton
        icon="3d"
        variant="secondary"
        type="button"
        label=""
        size="md"
        onClick={handleWebstreamOpen}
        aria-label={ariaLabel3DButton}
      />
    </>
  );
};
